import React, { useState } from "react";
import { Menu, Dropdown, Avatar, Modal, Form, Input, Button, message } from "antd";
import { connect } from "react-redux";
import { SettingOutlined, LogoutOutlined, UserSwitchOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOut } from "redux/actions/Auth";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { change_password } from "api/auth";

const menuItem = [
  {
    title: "Definições",
    icon: SettingOutlined,
    path: "/home",
  },
];

export const NavProfile = ({ auth, logout }) => {
  const [passwordModal, setPasswordModal] = useState({ visible: false });
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();

  const staffPicture = (data) => {
    if (data === undefined || data === null) return null;
    if (data?.picture !== undefined) {
      return data?.picture;
    }

    return `https://api.dicebear.com/9.x/initials/svg?seed=${data?.user?.contactName}`;
  };

  const handlePasswordChange = async (values) => {
    setIsLoading(true);
    try {
      await change_password({
        current_password: values.current_password,
        new_password: values.new_password,
      });

      message.success("Palavra-passe alterada com sucesso!");
      setPasswordModal({ visible: false });
      form.resetFields();
      //TODO: pensar neste assunto
      // Optional: Force re-login for security
      // logout();
      // history.push("/auth/login");
    } catch (error) {
      console.error("Password change error:", error);
      message.error(error?.response?.data?.message || "Erro ao alterar palavra-passe. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const closePasswordModal = () => {
    setPasswordModal({ visible: false });
    form.resetFields();
  };

  const validatePassword = (_, value) => {
    if (!value) {
      return Promise.reject(new Error("Por favor, insira uma senha!"));
    }
    if (value.length < 8) {
      return Promise.reject(new Error("A senha deve ter pelo menos 8 caracteres!"));
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) {
      return Promise.reject(new Error("A senha deve conter pelo menos uma letra maiúscula, uma minúscula e um número!"));
    }
    return Promise.resolve();
  };

  const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("new_password") === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("As senhas não coincidem!"));
    },
  });

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={staffPicture(auth?.data?.data)} />
          <div className="pl-3">
            <h4 className="mb-0">{auth?.data?.name}</h4>
            <h5 className="mb-0">{auth?.data?.role}</h5>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={el.path}>
                  <Icon type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
          {auth.data.user.loginType === "username" && (
            <>
              <Menu.Divider />
              <Menu.Item
                key={menuItem.length}
                onClick={() => {
                  setPasswordModal({ visible: true });
                }}
              >
                <span>
                  <UserSwitchOutlined />
                  <span className="font-weight-normal">Mudar palavra-passe</span>
                </span>
              </Menu.Item>
            </>
          )}
          <Menu.Divider />
          <Menu.Item
            key={menuItem.length + 1}
            onClick={(e) => {
              window.localStorage.removeItem("partners-md-auth");
              window.localStorage.removeItem("authToken");
              history.push("/auth/login");
            }}
          >
            <span>
              <LogoutOutlined />
              <span className="font-weight-normal">Terminar Sessão</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );

  return (
    <>
      <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
        <Menu className="d-flex align-item-center" mode="horizontal">
          <Menu.Item key="profile">
            <Avatar src={staffPicture(auth?.data)} />
          </Menu.Item>
        </Menu>
      </Dropdown>

      <Modal title="Alterar Palavra-passe" visible={passwordModal.visible} footer={null} onCancel={closePasswordModal} destroyOnClose={true}>
        <Form form={form} layout="vertical" onFinish={handlePasswordChange} autoComplete="off">
          <Form.Item label="Palavra-passe atual" name="current_password" rules={[{ required: true, message: "Por favor, insira a palavra-passe atual!" }]}>
            <Input.Password placeholder="Digite sua palavra-passe atual" />
          </Form.Item>

          <Form.Item label="Nova palavra-passe" name="new_password" rules={[{ validator: validatePassword }]}>
            <Input.Password placeholder="Digite a nova palavra-passe" />
          </Form.Item>

          <Form.Item
            label="Confirmar nova palavra-passe"
            name="confirm_password"
            dependencies={["new_password"]}
            rules={[{ required: true, message: "Por favor, confirme a nova palavra-passe!" }, validateConfirmPassword]}
          >
            <Input.Password placeholder="Confirme a nova palavra-passe" />
          </Form.Item>

          <div className="d-flex justify-content-end">
            <Button type="default" onClick={closePasswordModal} disabled={isLoading} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Confirmar
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default connect(null, { signOut })(NavProfile);
